import React from "react";
import { BusinessPlansPage } from "../../features";

export default BusinessPlansPage;
